export default __webpack_public_path__ + "static/media/delete.b903db10.svg";